/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

interface ButtonProps {
  color: 'white' | 'blue' | 'green';
  onClick?: () => void;
  children: React.ReactNode;
}

const Button = ({ color, onClick, children }: ButtonProps) => {
  const buttonStyle = css`
    padding: 12px 20px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    border: 0;
    border-radius: 4px;
    cursor: pointer;
    background: ${color === 'white'
      ? '#fff'
      : color === 'blue'
      ? '#6079FF'
      : '#277C05'};
    color: ${color === 'white' ? '#6079FF' : '#fff'};
  `;

  return (
    <button css={buttonStyle} type="button" onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
